/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Page_TitleInputs */

const cs_signing_page_title = /** @type {(inputs: Signing_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpisy`)
};

const en_signing_page_title = /** @type {(inputs: Signing_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing`)
};

/**
* | output |
* | --- |
* | "Signing" |
*
* @param {Signing_Page_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_page_title = /** @type {((inputs?: Signing_Page_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Page_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_page_title(inputs)
	return cs_signing_page_title(inputs)
});